import { render } from "./ParentTenant.vue?vue&type=template&id=cbee7296&scoped=true"
import script from "./ParentTenant.vue?vue&type=script&lang=js"
export * from "./ParentTenant.vue?vue&type=script&lang=js"

import "./ParentTenant.vue?vue&type=style&index=0&id=cbee7296&lang=css"
import "./ParentTenant.vue?vue&type=style&index=1&id=cbee7296&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbee7296"]])

export default __exports__